import { useEffect, useState, useCallback } from 'react';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useTranslation } from 'next-i18next';
import { CSSProperties } from 'styled-components';

import CpdTabScrollStyle from './style';

type CpdTabScrollProps = {
  value: number;
  onChange: (e: any, value: number) => void;
  headingHeight: number;
};

const CpdTabScroll = ({ value, onChange, headingHeight }: CpdTabScrollProps) => {
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const { t } = useTranslation('common');
  const handleScroll = useCallback(() => {
    const currentScrollPos = window.pageYOffset;
    if (headingHeight) {
      setVisible(currentScrollPos < headingHeight + 48);
    }
    setPrevScrollPos(currentScrollPos);
  }, [prevScrollPos]);

  const tabStyle = (): CSSProperties => {
    if (visible) {
      return { position: 'relative', marginBottom: '30px' };
    }
    return { position: 'fixed', top: '0px' };
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [prevScrollPos, visible, handleScroll]);

  return (
    <CpdTabScrollStyle style={tabStyle()}>
      <Box className="container">
        <Tabs value={value} onChange={onChange} variant="scrollable" scrollButtons={false}>
          <Tab label={t('cpd_course.tab_menu.course_detail')} />
          <Tab label={t('cpd_course.tab_menu.course_chapter')} />
          <Tab label={t('cpd_course.tab_menu.instructor')} />
          <Tab label={t('cpd_course.tab_menu.prepare_train')} />
        </Tabs>
      </Box>
    </CpdTabScrollStyle>
  );
};

export default CpdTabScroll;
